export enum ExtraFormType {
  Additional = 0,
  ExtraProtocolVisit = 1,
  EarlyCompletion = 2
}
